// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const userUpdateInDisplayNameOneMax = 200;

export const userUpdateInEmailOneMin = 3;
export const userUpdateInEmailOneMax = 320;

export const userUpdateInPasswordOneMax = 256;

export const userUpdateInRolesOneMax = 6;

export const UserUpdateIn = zod.object({
  "auth_source": zod.union([zod.enum(['local', 'entra']),zod.null()]).optional(),
  "display_name": zod.union([zod.string().min(1).max(userUpdateInDisplayNameOneMax),zod.null()]).optional(),
  "email": zod.union([zod.string().min(userUpdateInEmailOneMin).max(userUpdateInEmailOneMax),zod.null()]).optional(),
  "is_active": zod.union([zod.boolean(),zod.null()]).optional(),
  "password": zod.union([zod.string().min(1).max(userUpdateInPasswordOneMax),zod.null()]).optional(),
  "roles": zod.union([zod.array(zod.enum(['user', 'access_manager', 'monitor', 'asset_manager', 'industry_manager', 'admin'])).max(userUpdateInRolesOneMax),zod.null()]).optional()
});

export type UserUpdateIn = zod.input<typeof UserUpdateIn>;
export type UserUpdateInOutput = zod.output<typeof UserUpdateIn>;
